import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

import { reactive,ref, getCurrentInstance,watch } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'MerchandiseInfo',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const filterData = reactive({
    cat_id: '',
    brand_ids: [],
    status: '',
});
const allBrands = ref([])
const filteredBrands = ref<any[]>([]);
const searchKeyword = ref('') 

watch(() => filterData.cat_id,(newCatId) => {
    if (newCatId) {
        fetchBrandList(newCatId)
    } 
    allBrands.value = []
    filteredBrands.value = []
    filterData.brand_ids = []
})
const fetchBrandList = async (catId) => {
    try {
        const response = await proxy.$http.get('/admin/brands/getBrandList',{ cat_id: catId})
        if (response.code == 200) {
            allBrands.value = response.data
            filteredBrands.value = [...response.data]
        }
    } catch (error) {
        console.error('获取品牌列表失败:', error)
    }
}
const handleBrandSearch = (query) => {
    searchKeyword.value = query.toLowerCase()
    if (!query) {
        filteredBrands.value = [...allBrands.value]
        return
    }
    filteredBrands.value = allBrands.value.filter(brand => 
        brand.name.toLowerCase().includes(searchKeyword.value)
    )
}
const onExport = () => {
    if(filterData.brand_ids.length == 0 || !filterData.cat_id || filterData.status == ''){
        return proxy.$message({ type: 'error', message: '请选择品牌、分类和商品状态' })
    }
    const params = {
        status: filterData.status,                          
        brand_ids: filterData.brand_ids.join(',')
    };
    window.open(`${Keys.baseUrl}/admin/products/get_product_infos?${joinParams({...params,user_id:store.state.user.userInfo.id})}&is_export=1`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "mb15",
    shadow: "hover"
  }, {
    header: _withCtx(() => _cache[3] || (_cache[3] = [
      _createElementVNode("div", {
        class: "card-header",
        style: {"font-size":"14px","font-weight":"bold"}
      }, [
        _createElementVNode("span", null, "商品信息")
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "选择品牌：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: filterData.cat_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterData.cat_id) = $event)),
                placeholder: "选择分类",
                class: "filter-item cat-select"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "蛋糕",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "鲜花",
                    value: 8
                  }),
                  _createVNode(_component_el_option, {
                    label: "零食",
                    value: 5
                  }),
                  _createVNode(_component_el_option, {
                    label: "电子券",
                    value: 4
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filter-divider" }, " -- ", -1)),
              _createVNode(_component_el_select, {
                modelValue: filterData.brand_ids,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterData.brand_ids) = $event)),
                placeholder: "选择品牌",
                class: "filter-item cat-select",
                multiple: "",
                filterable: "",
                "remote-method": handleBrandSearch,
                remote: "",
                "reserve-keyword": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBrands.value, (brand) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: brand.id,
                      label: brand.name,
                      value: brand.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "商品状态：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: filterData.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterData.status) = $event)),
                placeholder: "选择商品状态",
                class: "filter-item status-select"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "上架",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "下架",
                    value: 2
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onExport,
                class: "export-btn"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "export-note" }, "注：根据分类、品牌，导出商品信息", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})